export enum ContainerReuseStatus {
  REQUEST_AND_APPROVE = -1,
  REQUESTED = 0,
  APPROVED = 1,
  REJECTED = 2,
  CANCELED = 3,
}
